const ES = {
    sunday: 'D',
    monday: 'L',
    tuesday: 'M',
    wednesday: 'M',
    thursday: 'J',
    friday: 'V',
    saturday: 'S',
    ok: 'Aceptar',
};

export default ES;
